import highcharts from "highcharts";
import drilldownInit from "highcharts/modules/drilldown";
import accessibilityInit from "highcharts/modules/accessibility";

let colorReal = "#ff9900";
let colorPresupuesto = "#109618";
let colorComparison = "#3b3eac";


export default {
  apply(){
    highcharts.setOptions({
      lang: {
        drillUpText: "◁ Volver a {series.name}",
        loading: "Cargando Información"
      },

      chart: {
        style: {
          fontFamily: "Roboto",
          color: "#444444"
        }
      },
      xAxis: {
        gridLineWidth: 1,
        gridLineColor: "#F3F3F3",
        lineColor: "#F3F3F3",
        minorGridLineColor: "#F3F3F3",
        tickColor: "#F3F3F3",
        tickWidth: 1
      },
      yAxis: {
        gridLineColor: "#F3F3F3",
        lineColor: "#F3F3F3",
        minorGridLineColor: "#F3F3F3",
        tickColor: "#F3F3F3",
        tickWidth: 1
      },
      legendBackgroundColor: "rgba(0, 0, 0, 0.5)",
      //"background2": "#505053",
      dataLabelsColor: "#B0B0B3",
      textColor: "#C0C0C0",
      contrastTextColor: "#F0F0F3",
      maskColor: "rgba(255,255,255,0.3)"
    });

    drilldownInit(highcharts);
    accessibilityInit(highcharts);

  },

  defaultConfig : {
      chart: {
        type: "column",
        zoomType: "x",
        events: {}
      },

      credits: {
        href: "https://darwin.irricrops.com",
        text: "by Irricrops"
      },

      title: {
        text: ""
      },

      subtitle: {
        text: ""
      },

      /*
      subtitle: {
        text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
      },
      */

      accessibility: {
        announceNewData: {
          enabled: true
        }
      },

      xAxis: {
        type: "category"
      },

      yAxis: {
        title: {
          text: ""
        }
      },

      legend: {
        //enabled: false
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            shadow: true,
            align: "center"
          }
        },
        column: {}
      },

      tooltip: {
        //headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        //nointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b> de costo <br/>'
        pointFormatter: null
      },

      series: [
        /*
        {
          name: "Real",
          color: colorReal,
          data: []
        },
        {
          name: "Año Anterior",
          color: colorComparison,
          data: []
        },
        {
          name: "Presupuesto",
          color: colorPresupuesto,
          data: []
        }
        */
      ],
      drilldown: {
        allowPointDrilldown: false
      }
    }


  }
